import { type Html, html, View } from 'rune-ts';
import klass from './MoreSection.module.scss';
import { font } from '../../../../../shared/typography';
import { getResizedUrl } from '../../../../../shared/util/image';

export class MoreSection extends View {
  constructor() {
    super({});
  }

  override template(): Html {
    return html`
      <section class="${klass.more}">
        <div class="${klass.content}">
          <div class="${klass.image_wrapper}">
            <img
              src="${getResizedUrl({
                url: '//s3.marpple.co/files/u_4648126/2025/2/original/d7ca402aa9197bf070dcd10cafdfab717b271be02.png',
                width: 400 * 2,
                quality: 85,
                format: 'webp',
              })}"
              alt="더보기 배경 이미지"
            />
          </div>
          <div class="${klass.desc} ${font('28_bold')}">
            크리에이터와 협업하고 싶은<br />
            브랜드 담당자이신가요?
          </div>
          <a href="/@/brand_commerce" target="_blank" class="${klass.detail} ${font('16_bold')}"
            >더 자세히 알아보기</a
          >
        </div>
      </section>
    `;
  }
}
